import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78ed6b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "copyright" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Privacy Policy")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("p", _hoisted_1, "© Aekos Trading Oy " + _toDisplayString(_ctx.year), 1),
    _createVNode(_component_router_link, {
      class: "pp-link",
      to: "/privacypolicy"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}